import { useId } from 'react';
import { Input } from '@/components/ui/input';

// Label-above-input number field. Distinct from InspectorField because
// the value type is number | undefined, not string. Used by
// footer.copyrightYear (4-digit year).

interface NumberFieldProps {
  label: string;
  value: number | undefined;
  onChange: (next: number | undefined) => void;
  placeholder?: string;
  helperText?: string;
  min?: number;
  max?: number;
}

export function NumberField({
  label,
  value,
  onChange,
  placeholder,
  helperText,
  min,
  max,
}: NumberFieldProps) {
  const id = useId();
  const describedById = helperText ? `${id}-desc` : undefined;

  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-foreground" htmlFor={id}>
        {label}
      </label>
      <Input
        id={id}
        size="sm"
        type="number"
        inputMode="numeric"
        value={value ?? ''}
        placeholder={placeholder}
        min={min}
        max={max}
        onChange={(e) => {
          const raw = e.target.value;
          if (raw === '') {
            onChange(undefined);
            return;
          }
          const parsed = Number.parseInt(raw, 10);
          onChange(Number.isNaN(parsed) ? undefined : parsed);
        }}
        aria-describedby={describedById}
      />
      {helperText ? (
        <p id={describedById} className="text-xs text-text-tertiary">
          {helperText}
        </p>
      ) : null}
    </div>
  );
}
